import styled from 'styled-components';
import { colors, Typography } from 'syngenta-digital-cropwise-react-ui-kit';

const TableStyled = styled.table`
  width: 100%;
`;
const TableContainer = styled.div`
  margin: 32px 16px 16px 16px;
  border: 1px solid var(--Neutral-neutral-20, #dfe2e7);
  border-radius: 4px;
  overflow: hidden;
`;
export const SkuContainer = styled.div`
  border-top: 1px solid #dfe2e7;
`;

const TrStyled = styled.tr`
  height: 52px;
  background-color: ${colors.neutral10};
  border: 1px solid #dfe2e7;
`;

const TrExpandableRow = styled.tr``;

interface IExpandedTdProps {
  showBottomBorder?: boolean;
}

const ExpandedTdStyled = styled.td<IExpandedTdProps>`
  padding: 8px 8px 8px 12px;
  width: 100%;
  box-sizing: border-box;
  ${({ showBottomBorder }) => showBottomBorder && 'border-bottom: 1px solid #dfe2e7;'}
`;

const ValueRowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ExpandedDiviverTdStyled = styled.td`
  align-items: center;
  border: 1px solid #dfe2e7;
`;

const RankText = styled(Typography.Text)`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.neutral100};
  margin: 0;
`;

const VarietyText = styled(Typography.Text)`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.neutral100};
  margin-left: 16px;
`;
export const DescriptionText = styled(Typography.Text)`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.neutral100};
  margin: -16px 0px 0px 20px;
`;

const NumberText = styled(Typography.Text)`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.neutral100};
  margin: 0;
  text-align: right;
  flex-shrink: 0;
`;
const CommonText = styled(Typography.Text)`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color ${colors.neutral100};
  margin-left: 22px;
`;

export {
  TableStyled,
  TrStyled,
  RankText,
  VarietyText,
  TrExpandableRow,
  ExpandedTdStyled,
  ValueRowWrapper,
  NumberText,
  TableContainer,
  CommonText,
};
